module.exports = __webpack_public_path__ + "img/w22-b3.4cf988fc.jpg";